module.exports = __webpack_public_path__ + "assets/img/driver-active-btn-fda20ae3.png";